<div
	*ngIf="showFeeWaiver"
	class="flex flex-col gap-3 md:gap-[21px] md:flex-row items-center md:items-end mb-4 md:justify-end md:mt-[-21px] md:mb-[45px] md:mx-0"
>
	<!-- <div *ngIf="false" class="flex-container"> -->
	<button
		(click)="createFeeWaiverRequest()"
		class="flex items-center justify-center w-full md:max-w-[225px] h-12 rounded border-[none] bg-[#0357ee1a]"
	>
		<span class="font-semibold text-sm text-[#0361f0] mb-0;"> Activation Fee Concession </span>
	</button>
	<button
		(click)="requestPriceConcession()"
		class="flex items-center justify-center w-full md:max-w-[225px] h-12 bg-[#0361f0] rounded border-[none]"
	>
		<span class="font-semibold text-sm text-white mb-0"> Transaction Fee Concession </span>
	</button>
</div>
<div class="biz-assign-page">
	<ng-container *ngIf="!showAssignTerminalUpdate; else assignTerminalUpdate">
		<h4 class="">Assign Terminals</h4>
		<form [formGroup]="form">
			<nz-form-item>
				<nz-form-control [nzErrorTip]="">
					<div class="custom-floating-input">
						<nz-select
							[nzSuffixIcon]="customDropDown"
							class="custom-select"
							custom-select
							formControlName="serialNo"
							labelId="serial"
							nzAllowClear
							nzShowSearch
						>
							<nz-option
								*ngFor="let item of assignedSerialNos?.records"
								[nzLabel]="item.serialNo | removeUnderscore"
								[nzValue]="item"
							>
								{{ item }}
							</nz-option>
						</nz-select>
						<label class="select-label" id="serial">Available Serial Numbers</label>
					</div>
				</nz-form-control>
			</nz-form-item>

			<nz-form-item>
				<nz-form-control [nzErrorTip]="">
					<div class="custom-floating-input">
						<nz-select
							[nzSuffixIcon]="customDropDown"
							class="custom-select"
							custom-select
							formControlName="location"
							labelId="location"
							nzAllowClear
							nzShowSearch
						>
							<nz-option
								*ngFor="let item of location?.agentLocations"
								[nzLabel]="item.locationName | removeUnderscore"
								[nzValue]="item"
							>
								{{ item }}
							</nz-option>
						</nz-select>
						<label class="select-label" id="location">Business location</label>
					</div>
				</nz-form-control>
			</nz-form-item>

			<!-- <nz-form-item>
				<nz-form-control>
					<nz-select [nzPlaceHolder]="'Business location'|translate | titlecase" [nzShowSearch]="true"
						[nzSuffixIcon]="customDropDown" class="" formControlName="location" name="location"
						style="width: 100%;">
						<nz-option *ngFor="let item of location?.agentLocations"
							[nzLabel]="item.locationName | removeUnderscore" [nzValue]="item">
							{{item}}
						</nz-option>
					</nz-select>
				</nz-form-control>
			</nz-form-item> -->

			<div class="flex-container align-center j-c-flex-end full-width m-b-20">
				<div (click)="launchAgentLocationModal()" class="flex-container align-center j-c-space-between cursor-pointer cta">
					<i nz-icon nzTheme="outline" nzType="plus"></i>&nbsp;&nbsp;
					<span>Add Business Location</span>
				</div>
			</div>

			<!-- <app-input-control [controlDef]="amountControl"></app-input-control> -->

			<small *ngIf="selectedSerial && selectedSerial.maximumAggregatorFee">
				<span class="text-grey">Maximum amount: </span>
				<strong>
					{{ 'moniepoint.currency_symbol' | translate }}
					{{ selectedSerial.maximumAggregatorFee | majorAmount | currency }}
				</strong>
			</small>

			<ng-template #customDropDown>
				<svg fill="none" height="8" viewBox="0 0 14 8" width="14" xmlns="http://www.w3.org/2000/svg">
					<path
						clip-rule="evenodd"
						d="M13.1363 0.263604C13.4878 0.615076 13.4878 1.18492 13.1363 1.5364L7.7363 6.9364C7.38483 7.28787 6.81498 7.28787 6.46351 6.9364L1.06351 1.5364C0.712035 1.18492 0.712035 0.615075 1.06351 0.263603C1.41498 -0.0878685 1.98483 -0.0878685 2.3363 0.263603L7.0999 5.02721L11.8635 0.263604C12.215 -0.087868 12.7848 -0.087868 13.1363 0.263604Z"
						fill="black"
						fill-rule="evenodd"
					/>
				</svg>
			</ng-template>

			<nz-alert *ngIf="selectedSerial" [nzDescription]="loanDesc" class="m-t-10 m-b-10 alert-box" nzType="info">
				<ng-template #loanDesc>
					<div nz-row>
						<div class="primary-color text-bold" nz-col nzSpan="2">
							<strong><i nz-icon nzTheme="outline" nzType="info-circle"></i></strong>
						</div>
						<div nz-col nzSpan="22">
							<h4>NOTE</h4>
							<div nz-row>
								<span class="text-grey" nz-col nzSpan="10">Activation amount: </span>
								<strong nz-col nzSpan="14">
									{{ 'moniepoint.currency_symbol' | translate }}
									{{ selectedSerial?.activationAmount | majorAmount | currency }}
								</strong>
							</div>
							<div nz-row>
								<span class="text-grey" nz-col nzSpan="10">BRM Earning:</span>
								<strong nz-col nzSpan="14">
									{{ 'moniepoint.currency_symbol' | translate }}
									{{ selectedSerial?.maximumAggregatorFee | majorAmount | currency }}
								</strong>
							</div>
							<div nz-row>
								<span class="text-grey" nz-col nzSpan="10">Insurance Fee:</span>
								<strong nz-col nzSpan="14">
									{{ 'moniepoint.currency_symbol' | translate }}
									{{ selectedSerial?.insuranceFee | majorAmount | currency }}
								</strong>
							</div>
							<div nz-row>
								<span class="text-grey" nz-col nzSpan="10">Total: </span>
								<strong nz-col nzSpan="14">
									{{ 'moniepoint.currency_symbol' | translate }}
									{{
										activationAmount / 100 +
											selectedSerial?.maximumAggregatorFee / 100 +
											selectedSerial?.insuranceFee / 100 | currency
									}}
								</strong>
							</div>
							<div class="refund-text">
								** This would be credited to your BRM account, you are permitted to refund the Business Owner
							</div>
						</div>
					</div>
				</ng-template>
			</nz-alert>

			<app-custom-error-display [errorMessage]="errorMessage"></app-custom-error-display>
			<div class="m-t-10">
				<app-custom-submit-button
					(submitForm)="assignTerminal()"
					[block]="true"
					[name]="'assign terminal' | translate | titlecase"
					[submitting]="submittingForm"
				>
				</app-custom-submit-button>
			</div>
		</form>
	</ng-container>
	<ng-template #assignTerminalUpdate>
		<app-custom-error-display [errorMessage]="errorMessage"></app-custom-error-display>
		<div class="m-t-10">
			<app-custom-submit-button
				(submitForm)="navigateToPosInventory()"
				[block]="true"
				[name]="'assign terminal' | translate | titlecase"
				[submitting]="submittingForm"
			>
			</app-custom-submit-button>
		</div>
	</ng-template>
</div>
